import { useRef } from "react";
import useQueryParams from "./useQueryParams";

export default function useInitialQueryParams() {
  const params = useQueryParams();
  const snapshotParams = useRef(params);
  return snapshotParams.current;
}
